<mat-form-field fxFlex="100">
  <mat-label>{{ label }}</mat-label>

  <mat-select
    [value]="value"
    [multiple]="multiple"
    [disabled]="disabled"
    [required]="required"
    [placeholder]="placeholder"
    [compareWith]="compareByUuid"
    (selectionChange)="changeValue($event.value)"
  >
    <mat-option *ngIf="!multiple" [value]="null">
      Brak
    </mat-option>

    <mat-option
      *ngFor="let item of filteredItems"
      [value]="item.uuid"
    >
      {{ item.name }}
    </mat-option>
  </mat-select>
</mat-form-field>
